module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAALCAYAAACksgdhAAABZElEQVQoU3WQP0iUARjGf8/hXbgJViA43KKQsx93Q4QegjQFubm4mLZE2yGRnKIk3CYuii4OjQotRSDfoSj48R1NUYRDQUGQKE0VZ94T3yfCcVzv9P55frzv84q2uFf1QNZsAAEQX4jZg7JOWmVKioqduQwZ+XTG/vlnPgCDLaKTy18MFe8ycuOQcHFRzRR6Fvpl0wT1d8y4Sa19O1AKhtmQqK+UNKlKzT0Ncw58jGPmDTvtkGAiCFgy3CFLryrvnWv84BTo/vqF4vdTIqCrBfzbd4tCf55jwZ/cbW5enVfztM0msBbFnAkWriHDQjGg1/BE4tGLUW1prua8zFugX/AwqpPFvAIyQBPxoDDMhWEX880ZxhPotcx9wVQU0wOsdnjE00LAT8O2xRvNhT4S/I7qzMrpu3MdoIbFUCFgPfGeekpirOrnNksdgLQlMb9X1nKaX4tKVU/LPP4fZLEelrWVzP8BHauB7IOO/jYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jiaolian.png
// module id = QiVZ
// module chunks = 1